/*
 * @Description: 
 * @Author: liusilin
 * @Date: 2026-09-03 17:39:09
 * @LastEditors: liusilin
 * @LastEditTime: 2026-09-03 20:46:22
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VConsole from 'vconsole'
import store from '@/store'
import axios from 'axios'

import {
  getUserInfoSuccess,
  getAppVerInfoSuccess,
  verifySmsCodeResult
} from "@/assets/js/client"

import './assets/styles/global.scss'

Vue.config.productionTip = false

axios.defaults.baseURL = process.env.VUE_APP_BASE_API;

// request interceptor
axios.interceptors.request.use(
  config => {
    // do something before request is sent
    let baseQuery = store.getters.getQuery
    if (config.method.toLowerCase() === 'post') {
      if (config.data instanceof URLSearchParams) {
        // form-urlencoded 请求：把全局 query（channel 等）并入，调用方显式传参优先
        Object.keys(baseQuery).forEach((key) => {
          const value = baseQuery[key];
          if (value !== undefined && value !== null && !config.data.has(key)) {
            config.data.append(key, value);
          }
        });
        return config;
      }
      config.data = {
        ...baseQuery,
        ...config.data
      };
    } else if (config.method.toLowerCase() === 'get') {
      config.params = {
        ...baseQuery,
        ...config.params
      };
    }

    return config;
  }
);

Vue.prototype.$axios = axios

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-new
  new VConsole()
}
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')

// 挂载方法到window对象
window.getUserInfoSuccess = getUserInfoSuccess
window.getAppVerInfoSuccess = getAppVerInfoSuccess
window.verifySmsCodeResult = verifySmsCodeResult